export default __webpack_public_path__ + "static/sesame2-b-2037fad6d19a287f2b2ff6f28e901e74.webp";